import React, { useEffect } from "react";
import "./Home.css";
import StoryBanner from "../components/StoryBanner";
import Tile from "../components/Tile";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="homepage-container">
      <div className="homepage-banner-wrapper">
        <StoryBanner />
      </div>

      <div className="homepage-tile-grid">
        <Tile
          imageSrc="/jurisprudencetile.png"
          buttonText="Islamic Jurisprudence on Finance"
          link="/index"
          wrapperClass="homepage-tile-wrapper"
          buttonClass="homepage-tile-button"
        />
        <Tile
          imageSrc="/economicstile.jpeg"
          buttonText="Principles of Austrian Economics"
          link="/index-economics"
          wrapperClass="homepage-tile-wrapper"
          buttonClass="homepage-tile-button"
        />
        <Tile
          imageSrc="/apexassettile.png"
          buttonText="The Apex Asset"
          link="/index-apex-asset"
          wrapperClass="homepage-tile-wrapper"
          buttonClass="homepage-tile-button"
        />
        <Tile
          imageSrc="/financialinstitutionstile.png"
          buttonText="Review of Contemporary Financial Systems"
          link="/index-finance"
          wrapperClass="homepage-tile-wrapper"
          buttonClass="homepage-tile-button"
        />
        <Tile
          imageSrc="/bitcoinguidetile.png"
          buttonText="Bitcoin Guide for Muslims"
          link="/index-islamicguide"
          wrapperClass="homepage-tile-wrapper"
          buttonClass="homepage-tile-button"
        />
        <Tile
          imageSrc="/bitcointile.jpeg"
          buttonText="Fundamentals of Bitcoin Tech"
          link="/index-bitcoin-tech"
          wrapperClass="homepage-tile-wrapper"
          buttonClass="homepage-tile-button"
        />
        <Tile
          imageSrc="/lightningtile.jpeg"
          buttonText="Fundamentals of Lightning Tech"
          link="/index-lightning"
          wrapperClass="homepage-tile-wrapper"
          buttonClass="homepage-tile-button"
        />
        <Tile
          imageSrc="/sovereignskillstile.png"
          buttonText="Sovereign Skills Lab"
          link="/index-diy"
          wrapperClass="homepage-tile-wrapper"
          buttonClass="homepage-tile-button"
        />
      </div>
    </div>
  );
}

export default Home;
